import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const EpAlert = ({
  alertType, icon, title, description, customId,
}) => (
  <div id={customId} data-testid={customId} className={`alert alert--${alertType}`} role="alert">
    {icon && <div className="alert__icon">{icon}</div>}
    <div className="alert__text">
      {title && <h6 className="alert__text-title">{title}</h6>}
      <p className="alert__text-description">{description}</p>
    </div>
  </div>
);

export default EpAlert;

EpAlert.defaultProps = {
  icon: '',
  title: '',
  customId: '',
};

EpAlert.propTypes = {
  alertType: PropTypes.oneOf(['warning']).isRequired,
  icon: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  customId: PropTypes.string,
};
